import { allowedProtocols } from './is-valid-url.model';

export const isValidUrl = (url: unknown): url is string => {
  if (typeof url !== 'string') return false;

  try {
    return allowedProtocols.includes(new URL(url).protocol);
  } catch {
    return false;
  }
};
